export const getPageRange = (currentPage, totalPages, maxPages = 10) => {
    let start = Math.max(0, Math.min(currentPage - Math.floor(maxPages / 2), totalPages - maxPages))
    let end = Math.min(start + maxPages, totalPages)

    if (end - start < maxPages) {
        start = Math.max(0, end - maxPages)
    }

    return Array.from({ length: end - start }, (_, i) => start + i)
}
